const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';

const HAD_SESSION_KEY = 'insight:had-session';

// Non-sensitive hint that this browser has previously held a session. Lets
// the app treat a session resolving null on cold load as suspect (retry once)
// instead of immediately showing the login page to a logged-in user.
export const markHadSession = () => {
  try {
    localStorage.setItem(HAD_SESSION_KEY, '1');
  } catch {
    // storage unavailable (private mode) - degrade silently
  }
};

export const clearHadSession = () => {
  try {
    localStorage.removeItem(HAD_SESSION_KEY);
  } catch {
    // storage unavailable - degrade silently
  }
};

export const hadSession = (): boolean => {
  try {
    return localStorage.getItem(HAD_SESSION_KEY) === '1';
  } catch {
    return false;
  }
};

// TEMPORARY DIAGNOSTICS (added 2026-06-10) for the iOS cold-load login race.
// Mirrors client-side auth failure events into the API logs ([CLIENT-DIAG])
// so both sides are visible together in staging logs. keepalive lets the
// beacon survive the axios interceptor's full-page redirect; credentials are
// included so the API can log which cookie NAMES this browser attaches.
export const reportClientDiag = (
  event: string,
  details: Record<string, unknown> = {}
): Promise<void> => {
  console.warn(`[CLIENT-DIAG] ${event}`, details);

  try {
    return fetch(`${API_URL}/client-diagnostics`, {
      method: 'POST',
      keepalive: true,
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, details }),
    })
      .then(() => undefined)
      .catch(() => undefined);
  } catch {
    // diagnostics must never break the app
    return Promise.resolve();
  }
};
